export default "__VITE_ASSET__DH7j1U4p__"